import styled from 'styled-components/macro'

export const Container = styled.div`
    display:grid;
    flex-wrap:wrap;
    align-items:center;
    height:100vh;
    
`;
export const FullWidthContainer = styled.div``;